module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "forward"
  }, [_c('a', {
    attrs: {
      "id": "pageii"
    }
  }, [_c('p', [_c('span', [_c('b', [_vm._v("Also by Harrison Owen")])])]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_c('span', [_c('i', [_vm._v("Spirit: Transformation and Development in Organizations")])])]), _c('br'), _vm._v(" "), _c('p', [_c('span', [_c('i', [_vm._v("Leadership Is")])])]), _c('br'), _vm._v(" "), _c('p', [_c('span', [_c('i', [_vm._v("Riding the Tiger")])])]), _c('br'), _vm._v(" "), _c('p', [_c('span', [_c('i', [_vm._v("The Millennium Organization")])])]), _c('br'), _vm._v(" "), _c('p', [_c('span', [_c('i', [_vm._v("Tales From Open Space")])])]), _c('br'), _vm._v(" "), _c('p', [_c('span', [_c('i', [_vm._v("Open Space Technology: A User’s Guide")])])])])]), _c('a', {
    attrs: {
      "id": "pageii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f0d5b8e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/also.vue
// module id = 60
// module chunks = 0